<template>
    <div class="step-three" id="step-confirmation">
        <h2 class="fs-24 font-smoothing">Tak for bestillingen</h2>
        <step>
            <div class="d-block d-lg-flex">
                <div class="w-100">
                    <p class="color-grey-3 font-smoothing fs-20 mb-2">Venligst tjek din email for yderligere information og en ordrebekræftelse.</p>
                  <div>
                    <p class="fs-20 font-smoothing mb-2 font-weight-bold"> Betaling: </p>
                    <p class="fs-18 color-grey-3 font-smoothing mb-2"> Betalingsmode: {{type}}</p>
                  </div>
                </div>
            </div>
        </step>
    </div>
</template>

<script>
  import Step from '@/components/Step'
  import { mapFields } from 'vuex-map-fields'
  import { mapGetters } from 'vuex'
  import { getAirports } from "../assets/airports"
  import { validateAirportsData } from "../utils/airportsVersionCheck"

  export default {
    name: "Confirmation",

    components: {
      Step,
    },

    data() {
      return {
        airports: []
      }
    },

    computed: {
       ...mapFields([
        'payment.type',
        'payment.coupon',
        'payment.couponType',
        'payment.couponError',
        'payment.couponExpirydate',
        'payment.totalPreCoupon'
      ]),
      ...mapGetters(['prices', 'payment', 'cart', 'bookingHome']),
      getDepartureAirportName() {
        if (!this.bookingHome.departureAirport) return '';
        const airport = this.airports.find(airport => airport.iata === this.bookingHome.departureAirport);
        return airport ? `${airport.name}(${airport.iata})` : this.bookingHome.departureAirport;
      },

      getTransitAirportNames() {
        if (!this.bookingHome.transitStops.length) return [];
        return this.bookingHome.transitStops
          .filter(stop => stop && stop.trim())
          .map(stopIata => {
            const airport = this.airports.find(airport => airport.iata === stopIata);
            return airport ? `${airport.name}(${airport.iata})` : stopIata;
          });
      }
    },

    mounted() {
      this.airports = getAirports();
      
      // Validate that airports data has required fields
      if (!validateAirportsData(this.airports)) {
        return; // Page will reload, no need to continue
      }
    }
  }
</script>
